// Reencoda uma foto pra WebP no navegador PRESERVANDO resolucao e transparencia.
//
// Existe por causa de uma combinacao especifica: o padrao Master exige 2000px+ e
// fundo transparente, e o formato natural pra isso na maquina do Ruan e PNG, que
// nessa resolucao passa dos 5 MB do teto de upload. A saida NAO e subir o teto —
// e trocar o formato: WebP carrega canal alfa e, medido nos 50 masters reais do
// acervo (lossless, 2000-2900px), a mediana e 1,1 MB e o maior 2,7 MB.
//
// ⚠️ So reencoda quando PRECISA (arquivo acima do teto). Foto que ja cabe sobe
// intacta — reencodar por via das duvidas seria perda de qualidade de graca.
//
// O alfa sobrevive: conferido no Chrome em 2026-08-08 encodando um canvas 2400px
// transparente e lendo os pixels de volta (canto vazio alpha=0, produto alpha=255,
// dimensoes preservadas).

const QUALIDADE = 0.95;

function carregar(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('nao foi possivel ler a imagem')); };
    img.src = url;
  });
}

/**
 * Devolve o proprio arquivo quando ele ja cabe no teto; senao, uma versao WebP
 * com a MESMA resolucao (nunca reduz o lado — reduzir e o que quebrava o master).
 */
export async function encolherSemPerderResolucao(file: File, tetoBytes: number): Promise<File> {
  if (file.size <= tetoBytes) return file;

  const img = await carregar(file);
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext('2d');
  if (!ctx) return file;
  // Sem fundo pintado: origem opaca cobre o canvas inteiro sozinha, e origem
  // transparente precisa continuar transparente.
  ctx.drawImage(img, 0, 0);

  const blob = await new Promise<Blob | null>((r) => canvas.toBlob(r, 'image/webp', QUALIDADE));
  if (!blob || blob.size >= file.size) return file; // nao ajudou — segue com o original

  const nome = file.name.replace(/\.[^.]+$/, '') + '.webp';
  return new File([blob], nome, { type: 'image/webp' });
}
